import { useState } from 'react';
import { FAQListItem } from '../components/faq-list-item.component';
import { defaultItem, faqTopics } from '../components/faq-topics.component';

export const AboutPage = (() => {

    const [currentMenu, setCurrentMenu] = useState(defaultItem);

    function onChooseMenu(menuKey: string) {
        const data = faqTopics[menuKey];
        setCurrentMenu(data);
    }

    return (
        <div className="h-100 col-12 col-xxl-10 mx-auto d-flex flex-column align-items-center">

            <div className="text-300 my-5 px-3 text-avenir-db bg-darker">NFTY</div>

            <div className="w-100 d-flex p-5">
                <div className="d-flex dropdown-menu-dark flex-column p-3 bg-darker">
                    {Object.keys(faqTopics).map(k => (
                        <FAQListItem active={currentMenu === faqTopics[k]} key={k} text={k} onClick={() => onChooseMenu(k)} />
                    ))}
                </div>
                <div className="flex-grow-1 p-3 bg-darker border-start border-secondary">
                    <div className="py-1 text-115 text-muted text-avenir-re">
                        {currentMenu}
                    </div>
                </div>
            </div>

        </div>
    );
});